import type { RootStore } from "store";
import { computed, makeAutoObservable, runInAction } from "mobx";
import api from "api";
import { IOrder } from "types/order";

class OrderStore {
	private rootStore: RootStore;
	items: IOrder[] = [];
	pastItems: IOrder[] = [];

	constructor(rootStore: RootStore) {
		makeAutoObservable(this);
		this.rootStore = rootStore;
	}
}

export default OrderStore;
